import { render, staticRenderFns } from "./BenefitCodeStats.vue?vue&type=template&id=5b835b8f&"
import script from "./BenefitCodeStats.vue?vue&type=script&lang=js&"
export * from "./BenefitCodeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports